import BentoCaseStudy from "../../components/BentoCaseStudy";
import manageCRM from "../../constrains/cases/manageCRM";

export default function ManageCRM() {
  return <BentoCaseStudy caseStudy={manageCRM} />;
}
